<template>
    <div class="box mt-5">
      <div class="row">
        <div class="col-md-12 m-3">
          <h3> Groups <ShowHideEye :showSection="showGroupSection" @toggle="showGroupSection = !showGroupSection"/></h3>
        </div>
      </div>
      <div class="row" v-if="showGroupSection">
        <div class="col-md-12">
          <form class="form" v-on:submit.prevent="addGroup">
            <div class="row">
              <div class="col-md-8">
                <fieldset>
                  <div class="form-wrap">
                    <div>
                      <label for="start_date">Start date</label>
                      <input id="start_date" type="date" v-model="newGroup.start_date" required>
                    </div>
        
                    <div>
                      <label for="base-price">Base price (£)</label>
                      <input id="base-price" type="number" v-model="newGroup.base_price">
                    </div>
        
                    <div v-if="tour_type == 'coach'">
                      <label for="region">Pickup region</label>
                      <v-select
                        v-model="newGroup.pick_up_point_region_id"
                        label="region_name"
                        id="region"
                        :options="regions"
                        index="id"
                        required
                      />
                    </div>
        
                    <div class="form-submit-inline">
                      <template v-if="this.getLoadStatus">
                        <button type="submit" class="button" disabled><span>Adding group...</span></button>
                      </template>
                      <template v-else>
                        <button type="submit" class="button" v-if="userRole == 1"><span>Add group</span></button>
                      </template>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="is-special-opt_out_from_emails">Show Places Taken ?</label>
                  <label class="switch">
                    <input id="opt_out_from_emails" type="checkbox" v-model="show_taken_places" @change="updateGroupDatatable">
                    <span class="switch__slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </form>
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            :key="tableKey"
            @editGroup="editGroup"
            @deleteGroupData="deleteGroupData"
            >
          </vdtnet-table>
        </div>
      </div>
    </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import ShowHideEye from "../ShowHideEye.vue";
import { mapGetters } from 'vuex'

export default {
  name: 'TourGroups',
  components: {
    ShowHideEye,
    VdtnetTable
  },
  props: {
    tour_type: String,
    regions:Array
  },
  created() {
    this.userRole
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = Number(localStorage.getItem("user_role"));
      if (user_role == 1) {
          this.showGroupSection = true
      }
      return user_role
    }
  },
  data() {
    return {
      showGroupSection: false,
      newGroup: {
        tour_id: this.$route.params.id,
      },
      tableKey: 0,
      options: {
        ajax: {
          url: `${this.$api}tours/${this.$route.params.id}/groups/table`,
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[0, 'desc']] 
      },
      fields: {
        start_date_1: {
          label: 'Start date',
          render: (data, type) => {
            const [year, month, day] = data.split('-');
            return `${day}/${month}/${year}`;
          }
        },
        pick_up_region: {
          label: 'Pickup Region',
        },
        passenger_count: {
          searchable: false,
          label: 'Places Taken',
        },
        actions: {
          sortable: false,
          searchable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/groups/${ row.group_id }" data-action="editGroup" class="icon icon--more">Edit</a>`
          }
        },
        delete_data: {
          label: ' ',
          render: (data, type, row) => {

            if (this.userRole != 1) {
              return '' 
            }

            return ' <a href="javascript:void(0)" data-action="deleteGroupData" class="icon icon--delete">Delete</a>'
          }
        }
      },
      show_taken_places:false
    }
  },
  methods: {
    addGroup () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups', {
        method: 'POST',
        body: JSON.stringify(this.newGroup),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$emit('getUpdatedTour')
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    editGroup(data) {
      this.$router.push({ name: 'tour-group', params: { id: data.group_id }})
    },
    deleteGroupData(data) {
      let __this = this
      // alert('delete group')
      // this.deleteGroup(data.group_id,data.start_date)
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + data.group_id + '/check-deletion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if (response) {
          console.log(response);
          if (response.can_delete) {
            __this.$swal({
                title: `Are you sure you want to delete group "${data.start_date}" ?`,
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  __this.deleteGroup(data.group_id)
                }
            });
          } else {
            __this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Sorry, this instance have active bookings.",
            });
          }
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    deleteGroup (groupId) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + groupId + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.tableKey++
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Sorry, this instance have active bookings.",
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
      .catch(error => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error,
        });
      });
    },
    updateGroupDatatable() {
      const ajaxUrl = `${this.$api}tours/${this.$route.params.id}/groups/table`

      const queryString = new URLSearchParams();

      if(this.show_taken_places){
        queryString.set('show_taken_places', 'yes');
      } else {
        queryString.set('show_taken_places', 'no');
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;
      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;
      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;
    },
    showNonDeletionMessage() {
      this.$swal({
        icon: "error",
        title: "Oops...",
        text: "Sorry, this instance have active bookings.",
      });
    }
  }        
}
</script>
